import { MaterialSymbols_100Thin } from '@expo-google-fonts/material-symbols/100Thin';

import { AndroidSymbolWeight } from '../..';
const weight: AndroidSymbolWeight = {
  name: 'MaterialSymbols_100Thin',
  font: MaterialSymbols_100Thin,
};
export default weight;
